import { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import "../styles/UtahAtAGlance.css";
import "../hexagon.css";
import "../styles/HexGrid.css";
import "../App.css";
import "../styles/UtahVerticals.css";

const auto = "/img/auto.webp";

const leftPanel = [
  {
    label: "Governor’s Corner",
    title: "Governor’s Corner",
    text: "A direct look at the Governor’s initiatives, vision, and statewide priorities shaping Utah’s future.",
    imagepath: "/img/glance-webp/utah_governor_img.webp",
    url: "/utah-at-a-glance/utah-governor",
    logo: "/img/governor/gov_logo.png",
  },
  {
    label: "Adventure Activities",
    title: "Utah Adventure Activities",
    text: "Utah offers thrilling adventure sports like rock climbing, mountain biking, rafting, and skiing...",
    imagepath: "/img/glance-webp/activities.png",
    url: "/utah-at-a-glance/adventure-activities",
  },
  {
    label: "Air Quality Index",
    title: "Utah Air Quality Index",
    text: "Utah’s air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels...",
    imagepath: "/img/glance-webp/traveller-with-beanie-relaxing-outdoors.webp",
    url: "/utah-at-a-glance/air-quality-index",
  },
  {
    label: "Airports",
    title: "Utah Airports",
    text: "Utah’s airports, led by Salt Lake City International, provide vital air connectivity across the state...",
    imagepath: "/img/glance-webp/airport.webp",
    url: "/utah-at-a-glance/utah-airports ",
  },
  {
    logo: auto,
    label: "Autism and DD",
    title: "Autism and DD",
    text: "Autism and Developmental Disablities-STATISTICS powered by URADD",
    imagepath: "/img/glance-webp/auto1.webp",
    url: "/utah-at-a-glance/autism-dd",
  },
  {
    label: "Budget",
    title: "Budget",
    text: "Explore Utah's budget overview: revenues, expenditures, and priorities across the state.",
    imagepath: "/img/glance-webp/utah-budget.webp",
    url: "/utah-at-a-glance/utah-budget",
  },
  {
    label: "Charging Stations",
    title: "Utah Charging Stations",
    text: "Utah is building a strong EV charging network, with fast chargers and public stations expanding across cities...",
    imagepath: "/img/glance-webp/charging-station.webp",
    url: "/utah-at-a-glance/charging-stations",
  },
  {
    label: "Cities",
    title: "Utah Cities",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/cities.webp",
    url: "/utah-at-a-glance/utah-cities",
  },
  {
    label: "Counties",
    title: "Utah Counties",
    text: "Utah has 29 diverse counties ranging from urban Salt Lake County to rural San Juan County, each offering unique landscapes...",
    imagepath: "/img/glance-webp/geoandinsights.webp",
    url: "/utah-at-a-glance/utah-counties",
  },
  {
    label: "Demographics",
    title: "Demographics",
    text: "Understand who lives in Utah—age groups, ethnicity, education, income, and population trends.",
    imagepath: "/img/glance-webp/demographics.png",
    url: "/utah-at-a-glance/demographics ",
  },
  {
    label: "Education and Intellectual Resources",
    title: "Education and Intellectual Resources",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/eduandresource.webp",
    url: "/utah-at-a-glance/education-and-intellectual-resources",
  },
  {
    label: "Employment",
    title: "Employment in Utah",
    text: "Track Utah’s job sectors, workforce trends, income levels, and economic output.",
    imagepath: "/img/glance-webp/jobs.webp",
    url: "/utah-at-a-glance/utah-employment ",
  },
  {
    label: "Federal Agencies",
    title: "Utah Federal Agencies",
    text: "Utah is home to various federal departments and agencies that support public services, defense, land management...",
    imagepath: "/img/glance-webp/new-york-city-ellis-island-great-hall.webp",
    url: "/utah-at-a-glance/federal-agencies",
  },
  {
    label: "Financial Institutions",
    title: "Financial Institutions",
    text: "Review personal finance trends, average incomes, economic stability, and financial health.",
    imagepath: "/img/glance-webp/finance3.webp",
    url: "/utah-at-a-glance/financial-institutions",
  },
  {
    label: "Geothermal Hotspots",
    title: "Utah Geothermal Hotspots",
    text: "Utah is rich in geothermal hotspots—particularly along the I‑15 corridor and in southwestern counties like Beaver...",
    imagepath: "/img/glance-webp/geo.webp",
    url: "/utah-at-a-glance/utah-geothermal-hotspots",
  },

  {
    label: "Hill Airforce Base",
    title: "Utah Hill Airforce Base",
    text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance...",
    imagepath: "/img/glance-webp/f-16.avif",
    url: "/utah-at-a-glance/hill-airforce-base",
  },
  {
    label: "Hospitals",
    title: "Utah Hospitals",
    text: "Utah hospitals provide high-quality medical care across the state, serving both urban and rural communities with advanced...",
    imagepath: "/img/glance-webp/hospital1.webp",
    url: "/utah-at-a-glance/hospitals",
  },
  {
    label: "Housing",
    title: "Housing in Utah",
    text: "Utah's housing market reflects rapid growth and high demand, driven by population increases, economic expansion, and a strong...",
    imagepath: "/img/glance-webp/housing.webp",
    url: "/utah-at-a-glance/utah-housing",
  },
  {
    label: "Libraries",
    title: "Utah Libraries",
    text: "Utah boasts a robust network of libraries",
    imagepath: "/img/glance-webp/interior.webp",
    url: "/utah-at-a-glance/utah-libraries",
  },
  {
    label: "MLM",
    title: "Utah MLM",
    text: "Utah is a major hub for multi-level marketing (MLM), home to several prominent MLM companies and a strong direct sales culture.",
    imagepath: "/img/glance-webp/mlm.webp",
    url: "/utah-at-a-glance/mlm",
  },
  {
    label: "Mines",
    title: "Utah Mines",
    text: "Uncover the industrial heart of Utah with a detailed look at its major mines",
    imagepath: "/img/glance-webp/mines.webp",
    url: "/utah-at-a-glance/utah-mines",
  },
  {
    label: "NonProfits",
    title: "Nonprofits",
    text: "Utah is home to numerous non-profit organizations dedicated to serving communities, protecting the environment, supporting vulnerable populations, and enhancing quality of life across the state.",
    imagepath: "/img/glance-webp/nonprofits.webp",
    url: "/utah-at-a-glance/utah-nonprofits",
  },
  {
    label: "Places to Visit",
    title: "Utah Places to Visit",
    text: "Utah offers breathtaking destinations such as Zion National Park, Bryce Canyon, Arches, Monument Valley, and Salt Lake City...",
    imagepath: "/img/glance-webp/stone-gate-bryce-canyon-national-park.webp",
    url: "/utah-at-a-glance/utah-places-to-visit",
  },
  {
    label: "Research Centers and Institutes",
    title: "Utah Research Centers and Institutes",
    text: "Research Centers and Institutes: Advancing Innovation Across Utah",
    imagepath: "/img/glance-webp/research.webp",
    url: "/utah-at-a-glance/research-centers-and-institutes",
  },
  {
    label: "Sports Club",
    title: "Utah Sports Club",
    text: "Highlighting major and minor league teams, college athletics, and community sports programs.",
    imagepath: "/img/glance-webp/sports.webp",
    url: "/utah-at-a-glance/sports-club",
  },
  {
    label: "Taxes",
    title: "Taxes",
    text: "Understand how Utah ranks in taxation, incentives, and economic competitiveness.",
    imagepath: "/img/glance-webp/taxes.webp",
    url: "/utah-at-a-glance/taxes ",
  },
  {
    label: "Unemployment Rate",
    title: "Utah Unemployment Rate",
    text: "Utah maintains one of the lowest unemployment rates in the nation, reflecting a resilient and stable economy.",
    imagepath: "/img/glance-webp/unemployment1.webp",
    url: "/utah-at-a-glance/unemployment-rate",
  },
  {
    label: "Voters Count",
    title: "Voters Count of Utah",
    text: "Engage with statistics on voting participation, registration, and electoral history.",
    imagepath: "/img/glance-webp/voterscount.webp",
    url: "/utah-at-a-glance/utah-voters-count",
  },
  {
    label: "Zip Codes",
    title: "Utah Zip Codes",
    text: " Utah ZIP codes organize the state's regions for efficient mail delivery and reflect geographic...",
    imagepath: "/img/glance-webp/close-up-magnifying-glass-map.webp",
    url: "/utah-at-a-glance/zipcodes",
  },
  
];

const generateHexRows = () => {
  const width = window.innerWidth;
  const rows = [];

  if (width <= 600) {
    // 🔹 Mobile: alternate 3 and 2 items per row
    for (let i = 0, toggle = true; i < leftPanel.length; ) {
      const count = toggle ? 3 : 2;
      rows.push(leftPanel.slice(i, i + count));
      i += count;
      toggle = !toggle;
    }
  } else if (width > 600 && width < 1030) {
    // 🔹 Tablet: 5 items per row
    for (let i = 0; i < leftPanel.length; i += 5) {
      rows.push(leftPanel.slice(i, i + 5));
    }
  } else {
    // 🔹 Desktop: 7 items per row
    for (let i = 0; i < leftPanel.length; i += 7) {
      rows.push(leftPanel.slice(i, i + 7));
    }
  }

  return rows;
};

const hexRows = generateHexRows();

const UtahAtAGlance = () => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const filteredCards = selectedTitle
    ? leftPanel.filter((item) => item.title === selectedTitle)
    : leftPanel;
  const [activeTab, setActiveTab] = useState("");

  return (
    <div>
      <LandingSection
        data={{ imageName: "login.webp", title: "Utah At a Glance" }}
      />
      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>
              One State. Many Stories. Dive into the data that defines Utah.
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Explore the heart of Utah its people, places, economy, and
              culture. From county level insights to infrastructure and
              lifestyle, this is your one stop overview of what defines the
              Beehive State.
            </p>
          </div>
        </div>
      </div>

      <div className="">
        <ul id="hexGrid">
          {leftPanel.slice(0, 9).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a className="hexLink" href={btn.url || "#"}>
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo1">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="">
        <ul id="hexGrid">
          {leftPanel.slice(9, 18).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a className="hexLink" href={btn.url || "#"}>
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo1">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="">
        <ul id="hexGrid" className="hexGrid-last-row">
          {leftPanel.slice(18, leftPanel.length).map((btn, idx) => (
            <li className="hex" key={idx}>
              <div className="hexIn">
                <a className="hexLink" href={btn.url || "#"}>
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo1">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* <div className="">
        <ul id="hexGrid" className="hexGrid-last-row">
          {leftPanel.slice(-2).map((btn, idx) => (
            <li className="hex hex-last-center" key={idx}>
              <div className="hexIn">
                <a className="hexLink" href={btn.url || "#"}>
                  <div className="hexBorder">
                    <div
                      className="img"
                      style={{
                        backgroundImage: `url(${btn.imagepath})`,
                      }}
                    >
                      <div className="imgOverlay"></div>
                    </div>
                  </div>

                  {btn.logo &&
                    (btn.label === "Autism and DD" ? (
                      <img
                        className="h-5 w-8 mt-[3rem] sm:h-14 sm:w-20 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ) : (
                      <img
                        className="h-7 w-7 mt-[2rem] sm:h-16 sm:w-16 sm:mt-[3rem]"
                        src={btn.logo}
                        alt={btn.label}
                      />
                    ))}

                  <div className="demo1">{btn.label}</div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div> */}

      <section className="why-section ">
        <div className="fit-text-container">
          <h1 className="background-title">SHAPING TOMORROW, TOGETHER</h1>
        </div>

        <h2 className="section-heading">What's Next for Utah?</h2>

        <p className="section-description">
          Utah is moving forward with bold ideas smart cities, clean energy, and
          inclusive growth powered by data. If you're passionate about shaping
          the future or want to collaborate, reach out to us and be part of the
          journey. Let’s build a stronger, smarter Utah together.
        </p>
        <div style={{ margin: "40px 0" }}>
          <ActionButton data="Contact Us" link="/contact-us" />
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default UtahAtAGlance;
